module.exports = __webpack_public_path__ + "img/petstairs19.382a00e0.jpg";